export const faqList = [
  {
    question: '乳交对女性胸部有伤害吗？',
    answer: '在正确的技巧和力度下，乳交不会对女性胸部造成伤害。关键在于充分润滑、控制力度、保持沟通。如果感到任何不适，应立即停止并调整方式。使用足量的润滑液可以有效减少摩擦，保护皮肤。',
  },
  {
    question: '胸部较小可以进行乳交吗？',
    answer: '当然可以。胸部大小并不影响乳交的可行性。对于胸部较小的情况，可以通过调整体位（如采用俯卧式）、使用双手辅助、增加润滑液等方式来实现。双方的配合和创意远比胸部大小重要。',
  },
  {
    question: '乳交需要使用润滑液吗？',
    answer: '强烈建议使用。润滑液可以显著减少皮肤摩擦，提升双方舒适度，降低皮肤损伤风险。建议选择水基或硅基润滑液，避免使用油基产品（如凡士林），因为油基产品不易清洗且可能影响私处健康。',
  },
  {
    question: '乳交能带来高潮吗？',
    answer: '对于男性而言，乳交可以通过持续的物理刺激达到高潮。对于女性而言，乳交虽然不直接刺激生殖器，但胸部是部分女性的敏感区域，过程中的亲密接触和视觉刺激可能带来心理上的愉悦和满足。部分女性可以通过乳交获得间接快感。',
  },
  {
    question: '乳交的卫生需要注意什么？',
    answer: '前后都应清洁胸部与私处。如果过程中涉及其他部位接触，应及时清洁。建议在乳交前沐浴，事后用温水和温和的清洁产品清洗。避免在胸部皮肤有破损、发炎或感染时进行。',
  },
  {
    question: '乳交是否适合所有人？',
    answer: '并非所有人都适合乳交。如果存在以下情况应避免：胸部有手术史或正处于术后恢复期、胸部皮肤有感染或破损、孕期或哺乳期（需咨询医生）、对胸部刺激感到不适的人群。建议在尝试前充分了解自身状况。',
  },
  {
    question: '如何与伴侣沟通想尝试乳交？',
    answer: '沟通的关键在于尊重和共情。可以在私密舒适的环境中自然提出，先表达对伴侣身体的欣赏，再说明这是一种增进亲密的方式。强调双向愉悦和随时可以停止的权利。避免在伴侣疲惫或情绪不佳时提出。',
  },
  {
    question: '乳交的持续时间多久合适？',
    answer: '没有固定的合适时长，应以双方舒适为准。新手建议从5-10分钟开始，逐步了解彼此的感受。关键在于过程中保持沟通，关注对方的反馈。如果任何一方感到疲劳或不适，应果断结束。',
  },
];